import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/main.css";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, Navigation } from "swiper/modules";
import Footer from "../Home/Footer";
import PhotoGallery1 from "../assets/img/PhotoGallery1.png";
import PhotoGallery2 from "../assets/img/PhotoGallery2.png";
import PhotoGallery3 from "../assets/img/PhotoGallery3.png";
import PhotoGallery4 from "../assets/img/PhotoGallery4.png";
import PhotoGallery5 from "../assets/img/PhotoGallery5.png";
import PhotoGallery6 from "../assets/img/PhotoGallery6.png";
import PhotoGallery7 from "../assets/img/PhotoGallery7.png";
import PhotoGallery8 from "../assets/img/PhotoGallery8.png";
import WhoWeAreImage from "../assets/img/Whowearesectionimage.jpg";
import AboutUsSlider1 from "../assets/img/AboutUsSlider1.png";
import AboutUsSlider2 from "../assets/img/AboutUsSlider2.png";
import AboutUsSlider3 from "../assets/img/AboutUsSlider3.png";

const galleryImages = [
  PhotoGallery1,
  PhotoGallery2,
  WhoWeAreImage,
  PhotoGallery3,
  PhotoGallery4,
  PhotoGallery5,
  PhotoGallery6,
  PhotoGallery7,
  PhotoGallery8,
];
const carouselData = [
  {
    image: AboutUsSlider1,
    title:
      "The Indo Pulses Development Association (IPDA) is a Commodity Stewardship Council (CSC) dedicated to enhancing the efficiency of the pulses value chain throughout India.",
  },
  {
    image: AboutUsSlider2,
    title:
      "IPDA has been formed under the Hon’ Balasaheb Thackeray Agribusiness and Rural Transformation (SMART) Project.",
  },
  {
    image: AboutUsSlider3,
    title:
      "IPDA is registered as a not-for-profit organisation under Section 8 of the Companies Act (2013).",
  },
];

const AboutCsc = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div>
      <main className="main">
        <section className="carousel-section" data-aos="fade-up">
          <Swiper
            modules={[Autoplay]}
            pagination={{ clickable: true }}
            navigation={false}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            loop={true}
            className="custom-swiper"
          >
            {carouselData.map((slide, index) => (
              <SwiperSlide key={index}>
                <div
                  className="carousel-item"
                  style={{ backgroundImage: `url('${slide.image}')` }}
                >
                  <div className="overlay">
                    <h3 style={{ color: "white" }}>{slide.title}</h3>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </section>

        <div className="section-separator" data-aos="fade-up">
          <h2 className="separator-title" style={{ color: "#d4561a" }}>
            About Us
          </h2>
          <div className="separator-line"></div>
        </div>

        <section
          id="collaboration"
          className="collaboration section"
          style={{ backgroundColor: "#d4561a" }}
        >
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-5 ml-auto" data-aos="fade-right">
                <h3 className="content-subtitle" style={{ color: "black" }}>
                  Who We Are?
                </h3>
                <p
                  style={{ color: "black", marginTop: "20px" }}
                  // data-aos="fade-up"
                  // className="fw-bold"
                >
                  The Indo Pulses Development Association (IPDA) is pioneering
                  Commodity Stewardship Council (CSC) dedicated to transforming
                  the country’s pulses sector. Established under the Hon’ble
                  Balasaheb Thackeray Agribusiness and Rural Transformation
                  (SMART) Project. IPDA is spearheaded by the Project
                  Implementation Unit (PIU)- Village and Social Transformation
                  Foundation (VSTF) with strategic support from the Government
                  of Maharashtra, the World Bank, and Grant Thornton Bharat LLP
                  as the Technical Service Provider (TSP).
                </p>
                <p
                  style={{ color: "black", marginTop: "10px" }}
                  data-aos="fade-up"
                  // className="fw-bold"
                >
                  IPDA functions as a collaborative, multi-stakeholder platform
                  uniting farmers, Farmer Producer Organizations (FPOs),
                  processors, industry players, policymakers, researchers, and
                  development agencies to drive systemic improvements across the
                  pulses value chain. From boosting productivity and promoting
                  innovation to shaping policies and enhancing market access,
                  IPDA aims to unlock the full potential of India’s pulses
                  sector.
                </p>
              </div>
              <div className="col-lg-6 position-relative" data-aos="zoom-in">
                <img
                  src={WhoWeAreImage}
                  alt="Collaboration"
                  className="img-fluid img-overlap rounded"
                  style={{
                    width: "100%",
                    height: "auto",
                    borderRadius: "10px",
                  }}
                  data-aos="flip-left"
                />
              </div>
            </div>
          </div>
        </section>

        <div className="section-separator" data-aos="fade-up">
          <h2 className="separator-title" style={{ color: "#d4561a" }}>
            Photo Gallery
          </h2>
          <div className="separator-line"></div>
        </div>

        <section
          id="photo-gallery"
          className="photo-gallery section"
          data-aos="fade-up"
        >
          <div className="container">
            <Swiper
              modules={[Pagination, Autoplay]}
              spaceBetween={20}
              autoplay={{ delay: 2000, disableOnInteraction: false }}
              loop={true}
              breakpoints={{
                0: {
                  slidesPerView: 1.2, // very small screens
                },
                480: {
                  slidesPerView: 2,
                },
                768: {
                  slidesPerView: 3,
                },
                1024: {
                  slidesPerView: 4.5,
                },
              }}
            >
              {galleryImages.map((image, index) => (
                <SwiperSlide key={index} data-aos="flip-left">
                  <div
                    className="card"
                    style={{
                      borderRadius: "10px",
                      overflow: "hidden",
                      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                    }}
                  >
                    <img
                      src={image}
                      alt={`Gallery ${index + 1}`}
                      className="img-fluid"
                      style={{
                        width: "100%",
                        height: "200px", // Adjust for mobile comfort
                        objectFit: "cover",
                      }}
                      data-aos="zoom-in"
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </section>

        <Footer />
      </main>
    </div>
  );
};

export default AboutCsc;
